import spCostsTemplate from './spcosts.html';

angular.module('org.saga.spcosts', ['org.saga.service']).directive('spCosts', [
   function () {
      return {
         restrict: 'E',
         template: spCostsTemplate,
         scope: {
            costs: '=',
            activity: '=',
            editable: '=',
            configuration: '=?',
            onCostEdit: '&',
            onCostDelete: '&',
            onCostDuplicate: '&',
            onCostComment: '&?'
         },
         controller: [
            '$scope',
            function ($scope) {
               $scope.editCost = function (cost, activity) {
                  $scope.onCostEdit({ cost: cost, activity: activity });
               };

               $scope.deleteCost = function (costId) {
                  $scope.onCostDelete({ costId: costId });
               };

               $scope.duplicateCost = function (cost, activity) {
                  $scope.onCostDuplicate({ cost: cost, activity: activity });
               };

               $scope.commentCost = function (cost) {
                  if ($scope.onCostComment) {
                     $scope.onCostComment({ cost: cost });
                  }
               };
            }
         ]
      };
   }
]);
